import script from "./UtmDictionaries.vue?vue&type=script&setup=true&lang=js"
export * from "./UtmDictionaries.vue?vue&type=script&setup=true&lang=js"

import "./UtmDictionaries.vue?vue&type=style&index=0&id=35e30628&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e30628"]])

export default __exports__